export default __webpack_public_path__ + "static/media/dashboard.daf3d34d.svg";